var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayrix = function SvgPlayrix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 54,
    fill: "none",
    viewBox: "0 0 192 54"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#playrix_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    fillRule: "evenodd",
    d: "M130.362 8.881c2.038 0 3.596 1.561 3.596 3.598 0 1.95-1.646 3.553-3.596 3.553a3.57 3.57 0 0 1-3.554-3.553c0-2.037 1.605-3.598 3.554-3.598m-75.066 6.284v-5.041h10.732v26.922h-5.461V15.165zm-6.92 22.303c2.655 0 4.886-.925 6.692-2.73 1.808-1.809 2.73-4.193 2.73-7.117 0-2.96-.922-5.344-2.73-7.152s-4.037-2.731-6.692-2.731c-2.037 0-4.923.462-4.923.462H38.07v26.305h5.462v-8.651q1.845 1.614 4.844 1.614m-3.692-6.309c-.807-.923-1.23-2.115-1.23-3.538s.423-2.613 1.23-3.536a4.09 4.09 0 0 1 3.154-1.386q1.905 0 3.116 1.386c.845.923 1.27 2.115 1.27 3.536 0 1.425-.425 2.615-1.27 3.538q-1.211 1.385-3.116 1.386a4.09 4.09 0 0 1-3.154-1.386M89.448 18.2h-5.502s-2.958-.462-5.23-.462c-2.73 0-5.075.963-6.997 2.846q-2.885 2.826-2.884 7.039-.001 4.21 2.884 7.037c1.922 1.883 4.268 2.806 6.999 2.806 2.039 0 3.77-.614 5.228-1.806v1.384h5.502zm-5.5 9.307a4.92 4.92 0 0 1-1.347 3.423c-.883.96-2.037 1.421-3.459 1.421a4.35 4.35 0 0 1-3.309-1.46c-.885-.962-1.345-2.116-1.345-3.384a4.62 4.62 0 0 1 1.307-3.309q1.326-1.383 3.345-1.383c2.923 0 4.808 2.077 4.808 4.692m34.738-4.27v13.807h-5.462V18.2h11.556v5.038zm8.948-5.037v18.844h5.502V18.2zm14.029 0 2.844 4.806 2.847-4.806h6.154l-5.923 9.152 6.345 9.692h-6.116l-3.307-5.345-3.269 5.345h-6.153l6.347-9.692-5.923-9.152zM95.514 44.507h5.769L111.782 18.2h-5.844l-4.386 11.652-4.23-11.652h-6.078l7.346 18.844z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "playrix_svg__a",
    width: 426.376,
    height: 287.376,
    x: -117.188,
    y: -116.688,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 58.594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3026_7566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_3026_7566",
    result: "shape"
  })))));
};
export default SvgPlayrix;